import React, { useState } from "react";
import { Button, OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { updateBoss } from "../../redux/evaluacion_desempenio/EvaluationMonitor/actions";
const UpdateBoss = (props) => {
  //*states
  const [loader, setLoader] = useState(false);
  //*variables
  const dispatch = useDispatch();
  return (
    <OverlayTrigger
      placement="auto"
      overlay={<Tooltip {...props}>Actualizar jefe</Tooltip>}
    >
      <Button
        size="sm"
        className="text-info"
        variant="link"
        type="button"
        disabled={
          loader ||
          !props.item.permiso_para_eliminar_actualizar.actualizacion_jefe
        }
        onClick={() => {
          if (props.item.permiso_para_eliminar_actualizar.actualizacion_jefe) {
            dispatch(
              updateBoss(
                {
                  evaluacion_competencia:
                    props.item.listado_evaluaciones
                      .evaluaciones_competencia[0][0],
                  evaluacion_factor:
                    props.item.listado_evaluaciones.evaluaciones_factor[0][0],
                },
                props.index,
                setLoader,
                props._getEvaluationMonitor
              )
            );
          }
        }}
      >
        {loader ? (
          <Spinner
            className="ml-2"
            animation="border"
            variant="primary"
            size="sm"
          />
        ) : (
          <i className="material-icons">sync</i>
        )}
      </Button>
    </OverlayTrigger>
  );
};

export default UpdateBoss;
